var map = {
	"./dealtNoTrumps_1.svg": 2272,
	"./dealtOnly789_1.svg": 2273,
	"./dealtOnlyQueensJacks_1.svg": 2274,
	"./loseLarge0_1.svg": 2275,
	"./loseLarge30_1.svg": 2276,
	"./loseLarge60_1.svg": 2277,
	"./take0Points_1.svg": 2278,
	"./take3Aces_1.svg": 2279,
	"./winLarge120_1.svg": 2280,
	"./winLarge61_1.svg": 2281,
	"./winLarge91_1.svg": 2282,
	"./winSmall120_1.svg": 2283,
	"./winSmall60_1.svg": 2284,
	"./winSmall90_1.svg": 2285,
	"./winZoleAll_1.svg": 2286,
	"./winZoleTwoAces_1.svg": 2287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;